import type { JSONContent } from '@tiptap/core';

import type { PageCreate } from '@/api/generated';

import type { PageDetail, PageForm } from './pageLabels';

/**
 * The B1 body for create, save and preview: the form's fields and the
 * content as TipTap JSON, exactly as the editor reported it. The portal never
 * produces HTML (I4, P2); the backend renders and sanitizes.
 */
export function toRequestBody(form: PageForm, content: JSONContent | null): PageCreate {
  const alt = form.headerImage?.alt.trim() ?? '';
  return {
    title: form.title.trim(),
    summary: form.summary.trim() || null,
    content: content ?? null,
    header_image_key: form.headerImage?.key ?? null,
    header_image_alt: form.headerImage && alt ? alt : null,
    links: form.links.map((link) => ({
      resource_type: link.resourceType,
      resource_id: link.resourceId,
    })),
  };
}

/** The form's values from a saved page; the content is held outside the form. */
export function formOf(page: PageDetail): PageForm {
  return {
    title: page.title,
    summary: page.summary ?? '',
    headerImage: page.headerImage,
    links: page.links,
  };
}

/**
 * A saved page as the same B1 body, for a card's Preview, so the card and
 * the editor send one shape (I4).
 */
export function bodyOf(page: PageDetail): PageCreate {
  return toRequestBody(formOf(page), page.content);
}
